





































import { Vue, Component, Emit, Prop ,Watch} from "vue-property-decorator";

// 請求方法
interface InvoiceMethod {
  yearmonth: string;
  method_div: number;
  created_at: string;
  updated_at: string;
}

@Component
export default class InvMethodTable extends Vue {

  // 請求方法 header
  private invMethodHeaders = [
    { text: "", value: -1 },
    { text: "新：電子/紙", value: 1 },
    { text: "旧：紙", value: 0 },
  ];


  @Prop({default:[]}) public value!: InvoiceMethod[][];

  @Emit() input() {
    return;
  }

  @Emit() change(yearIndex:number, index: number):{yearIndex:number, index:number} {
    //変更箇所一次元配列時の添字返却
    return {yearIndex: yearIndex, index: index};
  }
  

  private get Value(): InvoiceMethod[][] {
    return this.value;
  }

  private set Value(value: InvoiceMethod[][]) {
    this.input();
  }

  //請求方法 表示用年月度
  private dispYearmonth(value: string) {
    const month = Number(value.slice(4));
    return `${month}月`;
  }
}
